const toFiniteNumber = (value) => {
  if (value === null || value === undefined || value === "") return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const hasFiniteNumber = (value) =>
  value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));

const getAssigneeId = (task = {}) => task.assigned_to ?? task.assignee?.id_user ?? task.assignee?.id;

export const summarizeProjectResources = (tasks = [], assigneeOptions = []) => {
  const assigneeLabels = new Map(
    assigneeOptions.map((option) => [String(option.value ?? option.id), option.label]),
  );

  const totals = tasks.reduce(
    (summary, task) => {
      summary.plannedHours += toFiniteNumber(task.planned_hours);
      summary.actualHours += toFiniteNumber(task.actual_hours);
      summary.plannedCost += toFiniteNumber(task.planned_cost);
      summary.actualCost += toFiniteNumber(task.actual_cost);
      if (hasFiniteNumber(task.planned_hours)) summary.plannedHoursCount += 1;
      if (hasFiniteNumber(task.actual_hours)) summary.actualHoursCount += 1;
      if (hasFiniteNumber(task.planned_cost)) summary.plannedCostCount += 1;
      if (hasFiniteNumber(task.actual_cost)) summary.actualCostCount += 1;
      return summary;
    },
    {
      plannedHours: 0,
      actualHours: 0,
      plannedCost: 0,
      actualCost: 0,
      plannedHoursCount: 0,
      actualHoursCount: 0,
      plannedCostCount: 0,
      actualCostCount: 0,
    },
  );

  const people = new Map();
  tasks.forEach((task) => {
    const assigneeId = getAssigneeId(task);
    const key = assigneeId == null ? "unassigned" : String(assigneeId);
    const current = people.get(key) || {
      id: key,
      label:
        assigneeId == null
          ? "Sin responsable"
          : assigneeLabels.get(String(assigneeId)) ||
            task.assignee?.user ||
            task.assignee?.name ||
            "Responsable asignado",
      taskCount: 0,
      plannedHours: 0,
      actualHours: 0,
      progressTotal: 0,
    };
    current.taskCount += 1;
    current.plannedHours += toFiniteNumber(task.planned_hours);
    current.actualHours += toFiniteNumber(task.actual_hours);
    current.progressTotal += Math.min(100, Math.max(0, toFiniteNumber(task.progress_percentage)));
    people.set(key, current);
  });

  return {
    ...totals,
    hoursComplete: tasks.length > 0 && totals.actualHoursCount === tasks.length,
    costsComplete: tasks.length > 0 && totals.actualCostCount === tasks.length,
    hoursDeviation:
      tasks.length > 0 && totals.actualHoursCount === tasks.length
        ? totals.actualHours - totals.plannedHours
        : null,
    costDeviation:
      tasks.length > 0 && totals.actualCostCount === tasks.length
        ? totals.actualCost - totals.plannedCost
        : null,
    people: [...people.values()]
      .map((person) => ({
        ...person,
        averageProgress: person.taskCount ? person.progressTotal / person.taskCount : 0,
      }))
      .sort((left, right) => left.label.localeCompare(right.label, "es")),
  };
};
